import { Component, Input } from '@angular/core';
import { AgMediaUploaderModalService } from '../ag-media-uploader-modal.service';
import { AGMedia } from '@ag-common-lib/public-api';

@Component({
  selector: 'ag-shr-select-from-gallery',
  templateUrl: './select-from-gallery.component.html',
  styleUrls: ['./select-from-gallery.component.scss'],
})
export class SelectFromGalleryComponent {
  @Input() mediaItems: AGMedia[];

  constructor(private mediaUploaderService: AgMediaUploaderModalService) {}

  selectedItemsChange([selectedItem]: AGMedia[]) {
    this.mediaUploaderService.setSelectedFromGallery(selectedItem);
  }
}
